import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html } from 'lit';
import componentStyles from './tufts-clinical-trial-random.css.lit';

@customElement('tufts-clinical-trial-random')
export class TuftsClinicalTrialRandom extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Number, reflect: true, attribute: 'display' })
  displayCards = 3;

  connectedCallback(): void {
    super.connectedCallback();
    this.displayRandomCards();
  }

  displayRandomCards() {
    // Find the parent grid
    const gridElement = this.querySelector('tufts-grid');
    if (!gridElement) {
      return;
    }

    // Find all divs containing a 'tufts-clinical-trials-card' child
    const cardContainers = Array.from(
      gridElement.querySelectorAll('div:has(tufts-clinical-trials-card)')
    );
    // If the total number of cards is less than or equal to the number of cards to display, return
    // This prevents the removal of cards when the total number of cards is less than the number to display
    if (cardContainers.length <= this.displayCards) {
      return;
    }

    // Generate a set of unique random indexes
    const selectedIndexes = new Set<number>();
    while (selectedIndexes.size < this.displayCards) {
      const randomIndex = Math.floor(Math.random() * cardContainers.length);
      selectedIndexes.add(randomIndex);
    }

    // Remove the card containers that were not selected
    cardContainers.forEach((container, index) => {
      if (!selectedIndexes.has(index)) {
        container.remove();
      }
    });
  }

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-clinical-trial-random': TuftsClinicalTrialRandom;
  }
}
